<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Users</h1>
    </div>
    <div class="form-group col mb-n1 flx-center">
        <a class="btn btn-primary btn-sm float-right" [routerLink]="['/user-list/user-new']">New User</a>
    </div>
</div>

<div class="card mb-3 mt-2">
    <div class="card-body bg-light p-3">
        <div class="input-group input-group-sm w-lg-50">
            <div class="input-group-prepend">
                <span class="input-group-text bg-secondary text-light">Filter</span>
            </div>
            <input class="form-control" placeholder="Search" type="text" autofocus="autofocus" (keyup)="tableFiltring($event)" />
        </div>
    </div>
</div>

<ngx-datatable
    #table
    class="bootstrap-table"
    [rows]="items"
    [headerHeight]="61"
    [footerHeight]="38"
    [rowHeight]="'auto'"
    [columnMode]="'standard'"
    [scrollbarH]="true"
    [count]="totalItems"
    [offset]="0"
    [limit]="20"
>
    <ngx-datatable-column name="Email" prop="firstName" [cellClass]="'tb-col-3'" [headerClass]="'tb-col-3'" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                <a [routerLink]="['/user-list/user-edit', row.id]">
                    {{ value }}
                </a>
                <span class="hint"> — {{ row.email }}</span>
                <span class="badge badge-danger table-badge" *ngIf="!row.isEnabled"> Disabled </span>
            </div>
            <div class="cells-mobile"></div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Role"
        prop="roleName"
        [cellClass]="'tb-col-3 mobile-hide'"
        [headerClass]="'tb-col-3 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        [cellClass]="'actions-cell tb-col-3'"
        [headerClass]="'actions-cell tb-col-3'"
        [draggable]="false"
        [resizeable]="false"
        [sortable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div class="btn-group" ngbDropdown container="body" placement="bottom-right">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle>Actions</button>
                <div class="dropdown-menu" ngbDropdownMenu>
                    <a class="dropdown-item btn-sm" [routerLink]="['/user-list/user-password-edit', row.id]" ngbDropdownItem>Edit Password</a>
                    <a class="dropdown-item btn-sm" *ngIf="!row.isEnabled" (click)="confirmEnable(row, true)" ngbDropdownItem>Enable</a>
                    <a class="dropdown-item btn-sm" *ngIf="row.isEnabled" (click)="confirmEnable(row, false)" ngbDropdownItem>Disable</a>
                    <a class="dropdown-item btn-sm" (click)="confirmDelete(row)" ngbDropdownItem>Delete</a>
                </div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
            <datatable-pager
                [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'"
                [page]="curPage"
                [size]="pageSize"
                [count]="rowCount"
                [hidden]="!(rowCount / pageSize > 1)"
                (change)="table.onFooterPage($event)"
            >
            </datatable-pager>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>
